import { render, staticRenderFns } from "./StudioStudentsTab.vue?vue&type=template&id=9c6c1fba&scoped=true"
import script from "./StudioStudentsTab.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudioStudentsTab.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./StudioStudentsTab.vue?vue&type=style&index=0&id=9c6c1fba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6c1fba",
  null
  
)

export default component.exports